<div class="container">
  <img src="assets/images/logo-color-404.png">
  <h1 class="404-title">{{ 'NOT_FOUND_PAGE_TITLE' | i18next }}</h1>
  <h3>{{ 'NOT_FOUND_PAGE_TITLE_DESC_1' | i18next }}</h3>
  <p>{{ 'NOT_FOUND_PAGE_TITLE_DESC_2' | i18next }} <a href="/app/users">Home</a> {{ 'NOT_FOUND_PAGE_TITLE_DESC_3' | i18next }}</p>
</div>

